import React, { useState } from 'react'
import { CollateralDetail } from 'api'
import { DataGrid, GridId } from 'view/components/datagrid'
import { CollateralColumnDefs, collateralGridOptions, applyTransactionGetId } from './CollateralGridModel'
import { MaturedCollateralsFilterSwitch } from 'view/components/datagrid/toolbar/MaturedCollateralsFilterSwitch'
import { CollateralGridClipboardProcessor } from './CollateralGridClipboardProcessor'
import { useDebounce, useUserPreference } from 'view/hooks'

interface CollateralGridProps {
  collateralList: CollateralDetail[]
}

export const CollateralGrid: React.FunctionComponent<CollateralGridProps> = props => {
  const collateralList = useDebounce(props.collateralList, 300)
  const userPreference = useUserPreference()

  const [clipboardProcessor] = useState(() => new CollateralGridClipboardProcessor({ copyPasteFormat: userPreference.copyPasteFormat }))

  return (
    <DataGrid
      gridId={GridId.AdminCollateralGrid}
      applyTransactionGetId={applyTransactionGetId}
      gridOptions={collateralGridOptions}
      disableGrouping={true}
      clipboardProcessor={clipboardProcessor}
      customToolbarSwitches={[MaturedCollateralsFilterSwitch]}
      rowData={collateralList}
      columnDefs={CollateralColumnDefs}
    />
  )
}
